import React from 'react';
import PropTypes from 'prop-types';
import Component from '@ux/component';
import { BLOCK, DIRECTIONS } from './constants';

/**
 * Alert details toggle.
 *
 * The toggle button for opening and closing the additional alert details.
 *
 * @class Toggle
 * @public
 */
export default class Toggle extends Component {
  /**
   * Render the alert details toggle, but only if an `onClick` prop was
   * specified.
   *
   * @returns {ReactElement} div
   * @public
   */
  render() {
    const props = this.props;
    if (!props.onClick) {
      return null;
    }

    const classNames = [
      'uxicon',
      'uxicon-drop-' + (DIRECTIONS[props.display] || DIRECTIONS[BLOCK])
    ].join(' ');


    return (
      <button type='button' className='alert-toggle' onClick={ props.onClick } aria-label={ props.display === 'none' ? 'Open' : 'Close' }>
        <span className={ classNames } aria-hidden='true'></span>
      </button>
    );
  }
}

/**
 * Property types.
 *
 * @type {Object}
 * @private
 */
Toggle.propTypes = {
  /** Handler for when the alert details toggle is clicked */
  onClick: PropTypes.func.isRequired,
  /** How to display the additional alert details */
  display: PropTypes.oneOf(Object.keys(DIRECTIONS))
};



// WEBPACK FOOTER //
// ./node_modules/@ux/alert/toggle.js